import React from 'react'

export default function NotFound() {
  return (
    <h2 className=' vh-100 d-flex justify-content-center align-items-center text-danger fw-bold'>Not Found</h2>
  )
}
